import "../css/TextToPayInstructionsModal.css";
import Images from "../assets/images/Images";

const InstructionSection = (props) => {
  // props = stepCount ()
  return (
    <div className={"instructionSection"}>
      <div className={"instruction"}>
        <div className={"instructionText"}>
          <span style={{color: '#046ab0'}}>STEP 1:</span>
          <span>Click “Enroll Now!“ beside Text-to-Pay.</span>
        </div>
        <div className={"imageSection"}>
          <img className={"instructionImage"} src={Images.instructionSection1ImageA}></img>
        </div>
      </div>
      <hr/>
      <div className={"instruction"}>
        <div className={"instructionText"}>
          <span style={{color: '#046ab0'}}>STEP 2:</span>
          <span>Select ENROLL under Text Message. Next, enter the mobile phone number to receive text notifications. Then, click ENROLL again. You will receive a text confirmation. </span>
        </div>
        <div className={"imageSection"}>
          <img className={"instructionImage"} src={Images.instructionSection2ImageA}></img>
          <img className={"instructionImage"} src={Images.instructionSection2ImageB}></img>
        </div>
      </div>
      <hr/>
      <div className={"instruction"}>
        <div className={"instructionText"}>
          <span style={{color: '#046ab0'}}>STEP 3:</span>
          <span>Reply YES to the text confirmation. Then, return to My Account and click DONE. This will allow for future Text-to-Pay reminders. </span>
        </div>
        <div className={"imageSection"}>
          <img src={Images.instructionSection3ImageA}></img>
        </div>
      </div>
      <hr/>
      <div className={"instruction"}>
        <div className={"instructionText"}>
          <span style={{color: '#046ab0'}}>STEP 4:</span>
          <span>In My Account, click MAKE A PAYMENT to confirm a credit, debit or ACH account is selected as "default". This will be used for your Text-to-Pay payments. Note: Your on file and defaulted payment methods may be updated at anytime in My Account. </span>
        </div>
        <div className={"imageSection"}>
          <img src={Images.instructionSection4ImageA}></img>
          <img src={Images.instructionSection4ImageB}></img>
          <img src={Images.instructionSection4ImageC}></img>
        </div>
      </div>
    </div>
  );
};

export default InstructionSection;
